/* Learning/result rails only; never calculate, draw, price, submit, store or auto-advance. */
(() => {
  'use strict';
  if (window.WotfMobileRails) return;
  const mobile = matchMedia('(max-width: 749px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const zh = document.documentElement.lang.startsWith('zh');
  const profiles = [
    ['.ba-grid:not(.ba-learning-steps)', zh ? '占星三要素' : 'The three astrology building blocks'],
    ['.ba-learning-steps', zh ? '学习步骤' : 'Learning steps'],
    ['.zd-related-grid', zh ? '探索占星' : 'Explore astrology'],
    ['.journal-related__grid', zh ? '相关阅读' : 'Related stories'],
    ['.ft-directory-grid', zh ? '免费工具' : 'Free tools'],
    ['.bs-planet-arches', zh ? '太阳、月亮与水星' : 'Sun, Moon and Mercury'],
    ['.b3-cards', zh ? '太阳、月亮与上升' : 'Sun, Moon and Rising'],
    ['.zd-element-grid', zh ? '四种元素' : 'The four elements'],
    ['.zd-mode-grid', zh ? '三种模式' : 'The three modes'],
    ['.home-library__grid', zh ? '知识资料库' : 'The Arcana Library'],
    ['.meta-trinity__grid', zh ? '探索不同旅程' : 'Explore the different paths'],
    ['.nd-format-grid', zh ? '解读形式' : 'Reading formats'],
    ['.rr-related .rr-list', zh ? '相关阅读指南' : 'Related reading guides'],
    ['.commission-process__steps', zh ? '解读流程' : 'How your reading works']
  ];
  const records = new Map();
  let frame = 0, serial = 0;
  const cards = track => Array.from(track.children).filter(el => !el.hidden && getComputedStyle(el).display !== 'none');
  function update(record) {
    const {track, controls, count, previous, next} = record;
    const items = cards(track), active = mobile.matches && items.length > 1;
    track.toggleAttribute('data-mobile-rail', active);
    controls.hidden = !active;
    if (!active) {
      for (const [name, value] of record.original) value === null ? track.removeAttribute(name) : track.setAttribute(name, value);
      return;
    }
    if (track.tabIndex !== 0) track.tabIndex = 0;
    if (track.getAttribute('aria-label') !== record.label) track.setAttribute('aria-label', record.label);
    // Keep any native list/tab semantics; only an otherwise unnamed div becomes a region.
    if (track.tagName === 'DIV' && !record.original.find(([name]) => name === 'role')[1]) track.setAttribute('role', 'region');
    const edge = track.getBoundingClientRect().left;
    record.index = items.reduce((best, item, i) => Math.abs(item.getBoundingClientRect().left - edge) < Math.abs(items[best].getBoundingClientRect().left - edge) ? i : best, 0);
    const label = `${record.index + 1} / ${items.length}`;
    if (count.textContent !== label) count.textContent = label;
    previous.disabled = record.index === 0;
    next.disabled = record.index === items.length - 1;
  }
  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      for (const [track, record] of records) {
        if (track.isConnected) update(record);
        else { record.abort.abort(); record.resize?.disconnect(); record.controls.remove(); records.delete(track); }
      }
    });
  }
  function scan(scope = document) {
    if (!mobile.matches) return;
    for (const [selector, label] of profiles) for (const track of scope.querySelectorAll(selector)) {
      if (records.has(track) || cards(track).length < 2) continue;
      const original = ['tabindex', 'role', 'aria-label'].map(name => [name, track.getAttribute(name)]);
      if (!track.id) track.id = `MobileRail-${++serial}`;
      const controls = document.createElement('div');
      controls.className = 'mobile-rail-controls';
      controls.hidden = true;
      const count = document.createElement('span');
      count.className = 'mobile-rail-controls__count';
      const makeButton = (name, path) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', name);
        button.setAttribute('aria-controls', track.id);
        button.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="${path}" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        return button;
      };
      const previous = makeButton(zh ? '上一张' : 'Previous card', 'M19 12H5m6-6-6 6 6 6');
      const next = makeButton(zh ? '下一张' : 'Next card', 'M5 12h14m-6-6 6 6-6 6');
      controls.append(count, previous, next);
      track.after(controls);
      const abort = new AbortController();
      const record = {track, label, controls, count, previous, next, original, abort, index: 0};
      records.set(track, record);
      const go = index => {
        const items = cards(track);
        items[Math.max(0, Math.min(items.length - 1, index))]?.scrollIntoView({block: 'nearest', inline: 'start', behavior: reduced.matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => go(record.index - 1), {signal: abort.signal});
      next.addEventListener('click', () => go(record.index + 1), {signal: abort.signal});
      track.addEventListener('scroll', schedule, {passive: true, signal: abort.signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !mobile.matches || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? cards(track).length - 1 : record.index + (event.key === 'ArrowLeft' ? -1 : 1));
      }, {signal: abort.signal});
      if (typeof ResizeObserver === 'function') { record.resize = new ResizeObserver(schedule); record.resize.observe(track); }
      update(record);
    }
  }
  mobile.addEventListener('change', () => { scan(); schedule(); });
  document.addEventListener('input', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', event => { scan(event.target); schedule(); });
  document.addEventListener('shopify:section:unload', schedule);
  window.addEventListener('pageshow', () => { scan(); schedule(); });
  // Respect Shopify's draft-preview UI; never hide or edit the platform frame.
  let previewBar = null;
  const previewResize = typeof ResizeObserver === 'function' ? new ResizeObserver(previewClearance) : null;
  function previewClearance() {
    const bar = document.getElementById('PBarNextFrameWrapper');
    if (bar !== previewBar) {
      if (previewBar) previewResize?.unobserve(previewBar);
      previewBar = bar;
      if (bar) previewResize?.observe(bar);
    }
    let clearance = 0;
    if (bar && getComputedStyle(bar).visibility !== 'hidden') {
      const rect = bar.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && ['fixed','absolute'].includes(getComputedStyle(bar).position)) clearance = Math.ceil(innerHeight - Math.max(0,rect.top));
    }
    const value = `${clearance}px`;
    if (document.documentElement.style.getPropertyValue('--mobile-preview-clearance') !== value) document.documentElement.style.setProperty('--mobile-preview-clearance', value);
  }
  const previewObserver = new MutationObserver(previewClearance);
  previewObserver.observe(document.body, {childList: true});
  window.addEventListener('resize', previewClearance, {passive: true});
  window.visualViewport?.addEventListener('resize', previewClearance, {passive: true});
  window.addEventListener('pagehide', () => { previewObserver.disconnect(); previewResize?.disconnect(); });
  window.addEventListener('pageshow', event => { if (event.persisted) { previewObserver.observe(document.body, {childList: true}); previewBar = null; previewClearance(); } });
  previewClearance();
  window.WotfMobileRails = {scan};
  scan();
})();
